import { Flex, Text, Stack } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { formatDuration, formatEventTime } from 'src/meetings/utils/date-utils';
import { MeetingPlatformIcon } from './MeetingPlatformIcon';
import type { MeetingPlatform } from 'src/meetings/models';

type Props = {
  scheduledStartAt: string;
  scheduledEndAt: string;
  startAt?: string | null;
  endAt?: string | null;
  platform: MeetingPlatform | null;
};

export const EventTime = ({
  scheduledStartAt,
  scheduledEndAt,
  startAt,
  endAt,
  platform,
}: Props) => {
  const hasActualTimes = startAt != null && endAt != null;

  if (hasActualTimes) {
    const actualTimeText = formatEventTime(startAt, endAt);
    const actualDuration = formatDuration(startAt, endAt);
    const scheduledTimeText = formatEventTime(scheduledStartAt, scheduledEndAt);
    const scheduledDuration = formatDuration(scheduledStartAt, scheduledEndAt);

    return (
      <Stack gap={2}>
        <Flex align="center" gap="xxs">
          {platform && <MeetingPlatformIcon platform={platform} size={16} />}
          <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.6">
            {actualTimeText} {actualDuration}
          </Text>
        </Flex>
        <Text size="textXs" fw={FONT_WEIGHTS.medium} c="gray.5">
          Scheduled: {scheduledTimeText} {scheduledDuration}
        </Text>
      </Stack>
    );
  }

  const timeText = formatEventTime(scheduledStartAt, scheduledEndAt);
  const duration = formatDuration(scheduledStartAt, scheduledEndAt);

  return (
    <Flex align="center" gap="xxs">
      {platform && <MeetingPlatformIcon platform={platform} size={16} />}
      <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.6">
        {timeText} {duration}
      </Text>
    </Flex>
  );
};
